"use strict";

exports.__esModule = true;
exports.default = void 0;

var _PrimusPerson = _interopRequireDefault(require("./PrimusPerson.schema"));

var _PrimusPersonField = _interopRequireDefault(require("./PrimusPersonField"));

var _PrimusPerson2 = _interopRequireDefault(require("./PrimusPerson"));

var _PrimusMeasureField = _interopRequireDefault(require("./PrimusMeasureField"));

var _PrimusMeasure = _interopRequireDefault(require("./PrimusMeasure"));

var _PrimusMediaField = _interopRequireDefault(require("./PrimusMediaField"));

var _PrimusMedia = _interopRequireDefault(require("./PrimusMedia"));

var _PrimusImageField = _interopRequireDefault(require("./PrimusImageField"));

var _PrimusImage = _interopRequireDefault(require("./PrimusImage"));

var _PrimusBuildingPart = _interopRequireDefault(require("./PrimusBuildingPart.schema"));

var _PrimusChildrenField = _interopRequireDefault(require("./PrimusChildrenField"));

var _PrimusChecklistItemField = _interopRequireDefault(require("./PrimusChecklistItemField"));

var _PrimusPriorityWidget = _interopRequireDefault(require("./PrimusPriorityWidget"));

var _PrimusSection = _interopRequireDefault(require("./PrimusSection"));

var _PrimusList = _interopRequireDefault(require("./PrimusList"));

var _PrimusModule = _interopRequireDefault(require("./PrimusModule"));

var _PrimusModuleCondition = _interopRequireDefault(require("./PrimusModuleCondition"));

var _PrimusModuleDamage = _interopRequireDefault(require("./PrimusModuleDamage"));

var _PrimusModuleTask = _interopRequireDefault(require("./PrimusModuleTask"));

var _PrimusModuleWork = _interopRequireDefault(require("./PrimusModuleWork"));

var _PrimusChecklistItem = _interopRequireDefault(require("./PrimusChecklistItem"));

var _PrimusPreviewSection = _interopRequireDefault(require("./PrimusPreviewSection"));

var _PrimusPreviewModule = _interopRequireDefault(require("./PrimusPreviewModule"));

var _PrimusPreviewMedia = _interopRequireDefault(require("./PrimusPreviewMedia"));

var _PrimusPreviewWidget = _interopRequireDefault(require("./PrimusPreviewWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "fieldtypes": {
    "primusPerson": _PrimusPerson.default,
    "primusBuildingPart": _PrimusBuildingPart.default
  },
  "fields": {
    "primusChildren": _PrimusChildrenField.default,
    "primusMedia": _PrimusMediaField.default,
    "primusImage": _PrimusImageField.default,
    "primusPerson": _PrimusPersonField.default,
    "primusMeasure": _PrimusMeasureField.default,
    "primusChecklistItem": _PrimusChecklistItemField.default
  },
  "layouts": {
    "primusMedia": _PrimusMedia.default,
    "primusImage": _PrimusImage.default,
    "primusChecklistItem": _PrimusChecklistItem.default,
    "primusPerson": _PrimusPerson2.default,
    "primusMeasure": _PrimusMeasure.default,
    "primusSection": _PrimusSection.default,
    "primusList": _PrimusList.default,
    "primusModule": _PrimusModule.default,
    "primusModuleCondition": _PrimusModuleCondition.default,
    "primusModuleDamage": _PrimusModuleDamage.default,
    "primusModuleTask": _PrimusModuleTask.default,
    "primusModuleWork": _PrimusModuleWork.default,
    "primusPreviewSection": _PrimusPreviewSection.default,
    "primusPreviewModule": _PrimusPreviewModule.default,
    "primusPreviewMedia": _PrimusPreviewMedia.default,
    "section": _PrimusSection.default,
    "list": _PrimusList.default,
    "array": _PrimusList.default,
    "module": _PrimusModule.default
  },
  "widgets": {
    "primusPriority": _PrimusPriorityWidget.default,
    "primusPreview": _PrimusPreviewWidget.default
  }
};
exports.default = _default;
module.exports = exports.default;